import(/* webpackMode: "eager", webpackExports: ["LandingPage"] */ "/vercel/path0/apps/prono-rtbf/app/components/LandingPage.tsx");
